import { DEFAULT_TAB_CONFIG } from "../../../../../../stores/use-news-store";
import { DefaultActiveElements } from "../../../settings/features/news/defaults";

const DEFAULT_DATA = {
  config: {
    showTabs: false,
    type: "news",
    columns: 2,
    pagination: "infinite",
    cardBorderRadius: 3,
    activeElements: DefaultActiveElements,
    tabs: {
      t38kX5BODZ: { ...DEFAULT_TAB_CONFIG },
    },
  },
  tabs: [
    {
      id: "t38kX5BODZ",
      name: "",
      position: 0,
    },
  ],
};

export const NEWS_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "magazine",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "list",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "short_list",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "card",
    },
  },
];

export const buildTemplate = (variant, borderRadius) => ({
  ...DEFAULT_DATA,
  config: {
    ...DEFAULT_DATA.config,
    variant,
    cardBorderRadius: borderRadius,
  },
});
